<template>
  <v-app>    
    <core-app-bar />
    <core-drawer />
    <core-view />    
    <core-dialog />
    <core-wait />
  </v-app>
</template>

<script>

import './assets/site.css';

export default {
  name: 'App',
  components: {    
    CoreDrawer: () => import('@/components/core/Drawer'),
    CoreAppBar: () => import('@/components/core/AppBar'),
    CoreView: () => import('@/components/core/View'),
    CoreDialog: () => import('@/components/core/Dialog'),
    CoreWait: () => import('@/components/core/Wait')
  },
  data: () => ({
    //
  }),
};
</script>
